/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Form from './RewampedLanding/Form';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import * as types from '../../store/actions/types';
import { RootState } from '../../store/reducers';
import { getCodeFromWindowURL, getLocalStorageValue, getMinute, historyPath, historyPush, isUserLoggedIn, isUserRole, loadMyDetail, localStorageKeyValue, setLocalStorageValue } from '../../utils/handler';

import EquiviaImage from '../../assets/img/rewamp/brands/equivia.svg';
import HukImage from '../../assets/img/rewamp/brands/huk.svg';
import KrakenImage from '../../assets/img/rewamp/brands/kraken.svg';
import McQueenImage from '../../assets/img/rewamp/brands/mcqueen.svg';
import PrudentialImage from '../../assets/img/rewamp/brands/prudential.svg';
import Timeco2Image from '../../assets/img/rewamp/brands/timeco2.svg';
import VodafoneImage from '../../assets/img/rewamp/brands/vodafone.svg';
import SectionCard from './RewampedLanding/SectionCard';

import AliImage from '../../assets/img/rewamp/payments/ali.svg';
import AmazonImage from '../../assets/img/rewamp/payments/amazon.svg';
import AmericanExpressImage from '../../assets/img/rewamp/payments/american-express.svg';
import AppleImage from '../../assets/img/rewamp/payments/apple.svg';
import BitcoinImage from '../../assets/img/rewamp/payments/bitcoin.svg';
import BitplayImage from '../../assets/img/rewamp/payments/bitplay.svg';
import CashImage from '../../assets/img/rewamp/payments/cash.svg';
import CryptoImage from '../../assets/img/rewamp/payments/crypto.svg';
// import LinkImage from '../../assets/img/rewamp/payments/link.svg';
import MastercardImage from '../../assets/img/rewamp/payments/mastercard.svg';
import PaypalImage from '../../assets/img/rewamp/payments/paypal.svg';
import VisaImage from '../../assets/img/rewamp/payments/visa.svg';
import StatCard from './RewampedLanding/StatCard';
// import WireImage from '../../assets/img/rewamp/payments/wire.svg';

import Stat1Image from '../../assets/img/rewamp/stats/stat1.png';
import Stat2Image from '../../assets/img/rewamp/stats/stat2.png';
import Stat3Image from '../../assets/img/rewamp/stats/stat3.png';
import Stat4Image from '../../assets/img/rewamp/stats/stat4.png';
import Sec3Image from '../../assets/img/rewamp/stats/sec3.png'

import MarcAvatarImage from '../../assets/img/rewamp/review/marc-avatar.png'
import FmaAvatarImage from '../../assets/img/rewamp/review/fma-avatar.png'

import BrokerStatImage1 from '../../assets/img/rewamp/stats/broker-stats/icon1.png'
import BrokerStatImage2 from '../../assets/img/rewamp/stats/broker-stats/icon2.png'
import BrokerStatImage3 from '../../assets/img/rewamp/stats/broker-stats/icon3.png'
import TeamCarousel from './RewampedLanding/AgentsCarousel';
import ClientsCarousel from './RewampedLanding/ClientsCarousel';

import AdvantagesIcon from "../../assets/img/rewamp/icons/advantage.svg";
import DisadvantagesIcon from "../../assets/img/rewamp/icons/disadvantage.svg";
import { redirect_URL } from '../../config';

let currentDomainName: string | null = '';

const statContents = [
  {
    title: 'We Know What We’re Doing',
    subtitle: 'The Saw.com team is full of domain experts - and our CEO, Jeffrey Gabriel, has contributed to more than $500m in domain transitions and blockbuster sales like the record-breaking $13m for Sex.com. Our brokers are some of the brightest minds in the business, boasting years of knowledge and a proven track record of experience.',
    image: Stat1Image
  },
  {
    title: 'We Work With Select Clients',
    subtitle: 'We’re discerning about who we work with, and how we can help. We only collaborate with companies who we feel can gain the most impact from our services. We’re not a high-volume shop, so you never become ‘a number on the spreadsheet’. We take time to give your business the care and attention it deserves.',
    image: Stat2Image
  },
  {
    title: 'We Focus On Transparency',
    subtitle: 'Integrity is at our core - and, unlike other providers, Saw.com consistently ensures transparency and a seamless process in all that we do on behalf of our clients. We’ll always be upfront and honest about your domain, so if it’s not available (or the right buyer isn’t out there) we can explore alternative solutions before making a decision.',
    image: Stat3Image
  },
  {
    title: 'We Have a Proven Track Record',
    subtitle: 'More than anything, you need to know that your domain transaction is being handled by experts - and that you’re going to get the results to drive your business forward. Saw.com is the industry leader in selling and buying domains and has experience like no other when it comes to every aspect of brokerage.',
    image: Stat4Image
  }
]

const secDisadvantages = {
  disadvantages: [
    "You’re not sure where to begin (or how much to pay!) when it comes to acquiring your dream domain.",
    "You come up against privacy laws, struggling to locate domain owners and work out how to contact them.",
    "You may fail to use the best domain negotiation techniques or understand important terms in addition to price.",
    "You waste time and energy trying to transfer your domain name from one hosting server to another."
  ],
  advantages: [
    "You get market data, insights and a clear road map to make a suitable offer and maximize your chance of success.",
    "You leverage our expert knowledge and tools to find and contact domain owners to present your offer.",
    "You use our team to negotiate using techniques learned across two decades and 1,000s of transactions.",
    "You trust your dedicated consultant to assist with the transferring process quickly, efficiently and effectively."
  ]
}


export const RewampedLanding: React.FC = (): JSX.Element => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [videoLoading, setVideoLoading] = useState(true);
  let { search } = useLocation();
  const { previousAction = '', showLoginWindow = false } = useSelector((state: RootState) => state.mainReducer);

  const [showFaqModal, setShowFaqModal] = useState(false);

  useEffect(() => {
    if (!showLoginWindow) {
      if (previousAction === 'createAccount') {
        if (isUserLoggedIn()) {
          loadMyDetail();
        }
        dispatch({ type: types.PREVIOUS_ACTION, payload: '' });
      }
    }
  }, [showLoginWindow]);
  useEffect(() => {
    const query = new URLSearchParams(search);
    const dn: string | null = query.get('domainName') || query.get('domain') || getLocalStorageValue('domainName');
    if (dn) {
      currentDomainName = dn;
      setLocalStorageValue(localStorageKeyValue.domainName, currentDomainName);
      // setDomainName(dn);
      if (isUserLoggedIn()) {
        if (currentDomainName && isUserRole()) {
          loadMyDetail();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);
  useEffect(() => {
    if (showFaqModal) {
      document.body.style.overflow = "hidden";
      document.body.style.position = "fixed";
      document.body.style.width = "100%";
    } else {
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
    }
  }, [showFaqModal]);
  // useEffect(() => {
  //   //while linkedIn login success, app images are disappear on window close for some reason. so added this line.
  //   const code = getCodeFromWindowURL(window.location.href);
  //   if (code) {
  //     dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
  //   }

  //   setTimeout(() => {
  //     setVideoLoading(false);
  //   }, getMinute(5));
  // }, []);

  useEffect(() => {
    console.log("search", search)
    if (search) {
      localStorage.setItem("referralURL", search) 
      return
    };
    
    const referrer = document.referrer;

    if (!referrer) return;

    if (document.referrer.includes(redirect_URL)) return;

    // Ignore Stripe redirects
    if (referrer.includes(".stripe.com")) return;

    // Save FULL referral URL
    localStorage.setItem("referralURL", referrer);
  }, [search]);

  // const createAccount = () => {
  //   if (isUserLoggedIn()) {
  //     historyPush(historyPath.dashboard);
  //   } else {
  //     dispatch({ type: types.PREVIOUS_ACTION, payload: 'createAccount' });
  //     dispatch({ type: types.SIGN_UP_WITH_DOMAIN, payload: true });
  //     dispatch({ type: types.SHOW_LOGIN_WINDOW, payload: true });
  //   }
  // };

  return (
    <>
      <Helmet>
        <title>Saw.com Domain Broker Service For Your Business</title>
      </Helmet>
      <div className='rewamped-section-1'>
        <div className='sec1-left'>
          {/* <div className='sec1-head-1'>
            DONE-FOR-YOU DOMAIN ACQUISITION
          </div> */}
          <div className='sec1-head-2'>
            Domain Acquisition Is Complex. Saw.com Makes It Simple.
          </div>
          <div className="sec1-head-3">
            Create an account for less than 20 bucks to get private, VIP access to one of our highly-qualified domain experts. We’ll walk you through the negotiation process and give you the best chance of acquiring your perfect domain name.
          </div>
          <div className="faq-button">
            <button type="button" onClick={() => { setShowFaqModal(true) }}>FAQ</button>
          </div>
          {/* <div className='sec1-body'>
            <ul>
              <li>
                Half a billion dollars of domain deals
              </li>
              <li>
                Over 15 years of industry experience
              </li>
              <li>
                Trusted by the world’s biggest brands
              </li>
              <li>
                Stone-cold killers in domain acquisition
              </li>
            </ul>
          </div> */}
          {/* <div
            className="trustpilot-widget sec-tp"
            data-locale="en-US"
            data-template-id="5419b732fbfb950b10de65e5"
            data-businessunit-id="5e4179e55dd2990001312959"
            data-style-height="30px"
          >
            <a href="https://www.trustpilot.com/review/saw.com"
              target="_blank" rel="noopener">Trustpilot</a>
          </div> */}
          {/* <!-- TrustBox widget - Carousel --> */}
          <div className="trustpilot-widget sec-tp" data-locale="en-US" data-template-id="53aa8912dec7e10d38f59f36" data-businessunit-id="5e4179e55dd2990001312959" data-style-height="140px" data-style-width="100%" data-token="5db3a9e7-4def-4e52-adaa-fcacdc7e475a" data-stars="4,5" data-review-languages="en">
            <a href="https://www.trustpilot.com/review/saw.com" target="_blank" rel="noopener">Trustpilot</a>
          </div>
          {/* <!-- End TrustBox widget --> */}

        </div>
        <div className='sec1-form'><Form showFaqModal={showFaqModal} setShowFaqModal={setShowFaqModal} /></div>
      </div>
      <div className='rewamped-section-images'>
        <div className='images-head-1'>WE’VE SECURED PREMIUM DOMAINS FOR SOME OF THE WORLD’S BIGGEST BRANDS</div>
        <div className='logo-wrapper'>
          <img src={Timeco2Image} alt="" />
          <img src={McQueenImage} alt="" />
          <img src={KrakenImage} alt="" />
          <img src={HukImage} alt="" />
          <img src={EquiviaImage} alt="" />
          <img src={PrudentialImage} alt="" />
          <img src={VodafoneImage} alt="" />
        </div>
      </div>
      <SectionCard
        title='EXPERT DOMAIN GUIDANCE'
        subtitle='Boost Your Brand With a Dedicated Domain Consultant'
      >
        <div className='sec3-body'>
          <div className='sec3-body-left'>
            <div className="sec3-body-left-title">
              For just $19.95, we'll set up a consultation with a Saw.com expert
            </div>
            <div className="sec3-body-left-body1">They’ll spend a few hours learning more about your situation and talking you through the domain negotiation and acquisition process, before contacting you with information about up to 5 separate domains.
            </div>
            <div className="sec3-body-left-body2">You’ll learn the registrant, value and timeline for purchase - as well as some advice on negotiation strategies. So, for the price of a few cups of coffee, you can get expert advice from a Domain Broker who’s been there, done that and got the T-shirt for some of the world’s largest brands and the internet’s most valuable domains.</div>
            <div className="sec3-body-left-body3">
              <button onClick={() => {
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}>{t('get started')}</button></div>
          </div>
          <div className='sec3-body-right'><img src={Sec3Image} alt="" /></div>
        </div>
      </SectionCard>
      <SectionCard
        title='DOMAIN INDUSTRY EXPERTS'
        subtitle='Meet Our Brokers'
      >
        <div className="sec-broker">
          <div className="broker-stats">
            <div className="broker-stat">
              <img src={BrokerStatImage1} alt="" />
              <div className="broker-stat-info">
                <div className='broker-stat-key'>Domain Transactions</div>
                <div className='broker-stat-value'>1,000s</div>
              </div>
            </div>
            <div className="broker-stat">
              <img src={BrokerStatImage2} alt="" />
              <div className="broker-stat-info">
                <div className='broker-stat-key'>Domain Name Sales</div>
                <div className='broker-stat-value'>$550M+</div>
              </div>
            </div>
            <div className="broker-stat">
              <img src={BrokerStatImage3} alt="" />
              <div className="broker-stat-info">
                <div className='broker-stat-key'>Years of Experience</div>
                <div className='broker-stat-value'>15+</div>
              </div>
            </div>
          </div>
          <div className='broker-carousel'>
            <TeamCarousel />
          </div>
        </div>

      </SectionCard>

      <SectionCard
        title='HOW WE GET IT DONE'
        subtitle='Here’s How We Make Acquisitions Run Smoothly & Successfully'
        subtitle2='You Can Get Started For Just $19.95!'
      >
        <div className="sec-advantages">
          <div className="disadvantages">
            <div className="disadvantages-head disadvantages-tile">Without a Saw.com Consultant</div>
            {secDisadvantages.disadvantages.map((point) => <div className="disadvantages-tile">
              <img className='disadvantages-tile-icon' src={DisadvantagesIcon} alt="" />
              <div className="disadvantages-tile-text">{point}</div>
            </div>)}
          </div>
          <div className="advantages">
            <div className="advantages-head advantages-tile">With a Saw.com Consultant</div>
            {secDisadvantages.advantages.map((point) => <div className="advantages-tile">
              <img className='advantages-tile-icon' src={AdvantagesIcon} alt="" />
              <div className="advantages-tile-text">{point}</div>
            </div>)}
          </div>
        </div>

      </SectionCard>
      <div className='rewamped-section-images'>
        <div className='images-head-1'>WE OFFER LTO PLANS AND ACCEPT MULTIPLE PAYMENT OPTIONS</div>
        <div className='logo-wrapper'>
          <img src={MastercardImage} alt="" />
          <img src={VisaImage} alt="" />
          <img src={AmericanExpressImage} alt="" />
          <img src={BitcoinImage} alt="" />
          <img src={BitplayImage} alt="" />
          <img src={PaypalImage} alt="" />
          <img src={AppleImage} alt="" />
          <img src={AmazonImage} alt="" />
          <img src={AliImage} alt="" />
          <img src={CryptoImage} alt="" />
          <img src={CashImage} alt="" />
        </div>
      </div>
      <SectionCard
        title="WHAT WE'VE ACHIEVED"
        subtitle='Saw.com Success Stories'
      >
        <div className="sec-clients">
          <div className='clients-carousel'>
            <ClientsCarousel />
          </div>
        </div>
      </SectionCard>
      <SectionCard
        title="WHAT PEOPLE SAY"
        subtitle='Real Success, Real Clients'
        gradClass='grad-sec-review'
      >
        <div className="sec-review">
          <div className="sec-review-child">
            <div className="review-desc">
              “When starting a company, the Saw.com broker service team are some of the first people I call. A memorable name, and the domain and social handles behind it, creates a huge amount of brand equity right out the gate — no matter how big or how small your company is. From diapers.com to jet.com (and many more to come!) the Saw.com domain broker team has helped my companies be seen.”
            </div>
            <div className="review-card">
              <img src={MarcAvatarImage} alt="" />
              <div className="reviewer">
                <div className='reviewer-name'>MARC LORE</div>
                <div className='reviewer-desg'>Serial Entrepreneur</div>
              </div>
            </div>
          </div>
          <div className="sec-review-child">
            <div className="review-desc">
              “We have worked with Saw.com since their inception and would not work with anyone else. They help us in all facets of business - from sales and transfers to renewals, SSL issues and any other matters that may arise. You will not find a better, more trustworthy business that has maximized our profits.”
            </div>
            <div className="review-card">
              <img src={FmaAvatarImage} alt="" />
              <div className="reviewer">
                <div className='reviewer-name'>FUTURE MEDIA ARCHITECTS</div>
              </div>
            </div>
          </div>
        </div>
      </SectionCard>
      <SectionCard
        title="YOUR ADVANTAGE IN DOMAIN DEALS"
        subtitle='Why Businesses Trust Saw.com for Premium Domain Deals'
        gradClass="grad-sec-8"
      >
        <div className='sec-8'>
          {
            statContents.map(({ title, subtitle, image }, index) => (
              <StatCard key={index} title={title} subtitle={subtitle} statImage={image} />
            ))
          }
        </div>

      </SectionCard>
    </>
  );
};
export default RewampedLanding;
